export const translations = {
  zh: {
    // 通用
    loading: '處理中...',
    refresh: '重新整理',
    delete: '刪除',
    add: '新增',
    confirm: '確認',
    cancel: '取消',
    
    // 頁面標題
    appTitle: 'Hot Update 管理',
    configManagement: '配置管理',
    versionControl: '版本控制', // 保留舊的 key 以防其他地方使用
    ipWhitelist: 'IP 白名單',
    
    // 版本控制
    versionControlTitle: '版本控制系統',
    addNewVersion: '新增版本',
    versionNumber: '版本號碼',
    versionPlaceholder: '例如: 1.2.3',
    operatingSystem: '作業系統',
    macVersionList: 'macOS 版本清單',
    winVersionList: 'Windows 版本清單',
    status: '狀態',
    version: '版本',
    switchStatus: '變更狀態',
    operation: '操作',
    noVersions: '目前沒有版本',
    deleteVersion: '確定要刪除 {os} 版本 {version} 嗎？',
    
    // URL 設定
    urlSettingsTitle: '網址設定',
    environment: '環境',
    url: '網址',
    urlPlaceholder: '例如: https://example.com',
    prod: '正式環境',
    grayEnv: '灰度環境',
    setUrl: '設定網址',
    loadUrlsFailed: '載入網址設定失敗',
    pleaseEnterUrl: '請輸入網址',
    invalidUrlFormat: '網址格式不正確',
    addUrlFailed: '設定網址失敗',
    urlNotSet: '尚未設定',
    
    // 狀態標籤
    disabled: '停用',
    production: '正式版',
    gray: '灰度測試',
    
    // IP 白名單
    ipWhitelistTitle: '灰度 IP 白名單管理',
    addNewIp: '新增 IP 位址',
    name: '名稱',
    namePlaceholder: '例如: John',
    ipAddress: 'IP 位址',
    ipPlaceholder: '例如: 192.168.1.1',
    currentIpWhitelist: '目前的 IP 白名單',
    noIpRecords: '目前沒有 IP 白名單記錄',
    deleteIp: '確定要刪除 IP {ip} 嗎？',
    ipAlreadyExists: 'IP {ip} 已存在於白名單中',
    
    // 新的 URL 設定頁面
    urlConfiguration: 'URL 設定',
    currentConfiguration: '目前設定',
    platform: '平台',
    action: '操作',
    notConfigured: '尚未設定',
    updateConfiguration: '更新設定',
    grayEnvironmentUrl: '灰度環境 URL',
    prodEnvironmentUrl: '正式環境 URL',
    saving: '儲存中...',
    saveConfiguration: '儲存設定',
    loadConfigFailed: '載入設定失敗',
    configSaved: '設定儲存成功',
    saveConfigFailed: '儲存設定失敗',
    
    // 錯誤訊息
    loadVersionsFailed: '載入版本清單失敗',
    pleaseEnterVersion: '請輸入版本號碼',
    addVersionFailed: '新增版本失敗',
    updateStatusFailed: '更新狀態失敗',
    deleteVersionFailed: '刪除版本失敗',
    loadIpListFailed: '載入 IP 白名單失敗',
    pleaseEnterNameAndIp: '請輸入名稱和 IP 位址',
    invalidIpFormat: 'IP 位址格式不正確',
    addIpFailed: '新增 IP 失敗',
    deleteIpFailed: '刪除 IP 失敗',
    noUrlConfigured: '無法切換到 {status} 狀態：尚未配置 {env} 環境的網址',
    remoteFileNotFound: '無法切換到 {status} 狀態：在 {env} 環境中找不到文件 {filename}',
  },
  en: {
    // 通用
    loading: 'Processing...',
    refresh: 'Refresh',
    delete: 'Delete',
    add: 'Add',
    confirm: 'Confirm',
    cancel: 'Cancel',
    
    // 頁面標題
    appTitle: 'Hot Update Management',
    configManagement: 'Configuration Management',
    versionControl: 'Version Control', // 保留舊的 key 以防其他地方使用
    ipWhitelist: 'IP Whitelist',
    
    // 版本控制
    versionControlTitle: 'Version Control System',
    addNewVersion: 'Add New Version',
    versionNumber: 'Version Number',
    versionPlaceholder: 'e.g. 1.2.3',
    operatingSystem: 'Operating System',
    macVersionList: 'macOS Versions',
    winVersionList: 'Windows Versions',
    status: 'Status',
    version: 'Version',
    switchStatus: 'Change Status',
    operation: 'Actions',
    noVersions: 'No versions available',
    deleteVersion: 'Are you sure to delete {os} version {version}?',
    
    // URL 設定
    urlSettingsTitle: 'URL Settings',
    environment: 'Environment',
    url: 'URL',
    urlPlaceholder: 'e.g. https://example.com',
    prod: 'Production',
    grayEnv: 'Gray',
    setUrl: 'Set URL',
    loadUrlsFailed: 'Failed to load URL settings',
    pleaseEnterUrl: 'Please enter URL',
    invalidUrlFormat: 'Invalid URL format',
    addUrlFailed: 'Failed to set URL',
    urlNotSet: 'Not set',
    
    // 狀態標籤
    disabled: 'Disabled',
    production: 'Production',
    gray: 'Gray Testing',
    
    // IP 白名單
    ipWhitelistTitle: 'IP Whitelist Management',
    addNewIp: 'Add New IP Address',
    name: 'Name',
    namePlaceholder: 'e.g. John',
    ipAddress: 'IP Address',
    ipPlaceholder: 'e.g. 192.168.1.1',
    currentIpWhitelist: 'Current IP Whitelist',
    noIpRecords: 'No IP whitelist records',
    deleteIp: 'Are you sure to delete IP {ip}?',
    ipAlreadyExists: 'IP {ip} already exists in whitelist',
    
    // 新的 URL 設定頁面
    urlConfiguration: 'URL Configuration',
    currentConfiguration: 'Current Configuration',
    platform: 'Platform',
    action: 'Action',
    notConfigured: 'Not configured',
    updateConfiguration: 'Update Configuration',
    grayEnvironmentUrl: 'Gray Environment URL',
    prodEnvironmentUrl: 'Production Environment URL',
    saving: 'Saving...',
    saveConfiguration: 'Save Configuration',
    loadConfigFailed: 'Failed to load configuration',
    configSaved: 'Configuration saved successfully',
    saveConfigFailed: 'Failed to save configuration',
    
    // 錯誤訊息
    loadVersionsFailed: 'Failed to load version list',
    pleaseEnterVersion: 'Please enter version number',
    addVersionFailed: 'Failed to add version',
    updateStatusFailed: 'Failed to update status',
    deleteVersionFailed: 'Failed to delete version',
    loadIpListFailed: 'Failed to load IP whitelist',
    pleaseEnterNameAndIp: 'Please enter name and IP address',
    invalidIpFormat: 'Invalid IP address format',
    addIpFailed: 'Failed to add IP',
    deleteIpFailed: 'Failed to delete IP',
    noUrlConfigured: 'Cannot switch to {status} status: {env} environment URL not configured',
    remoteFileNotFound: 'Cannot switch to {status} status: File {filename} not found in {env} environment',
  },
};

export type TranslationKey = keyof typeof translations.zh;

export const t = (key: TranslationKey, language: 'zh' | 'en', replacements?: Record<string, string>): string => {
  let text = translations[language][key] || translations.zh[key];
  
  if (replacements) {
    Object.keys(replacements).forEach(placeholder => {
      text = text.replace(`{${placeholder}}`, replacements[placeholder]);
    });
  }
  
  return text;
}; 